
import { buildSpatialRankPayload } from './gnn-placement-contract.js';

let worker=null;
let workerState='idle';
let requestId=0;
const pending=new Map();
const resultCache=new Map();
const inFlightByPayload=new Map();
const RESULT_CACHE_LIMIT=64;
let lastModelPath=null;
let cacheHits=0;
let inFlightHits=0;
let rankRequests=0;

function payloadCacheKey(payload){
  return JSON.stringify(payload);
}

function getCachedResult(key){
  if(!resultCache.has(key))return undefined;
  const value=resultCache.get(key);
  resultCache.delete(key);
  resultCache.set(key,value);
  return value;
}

function cacheResult(key,value){
  if(!value)return;
  if(resultCache.has(key))resultCache.delete(key);
  resultCache.set(key,value);
  while(resultCache.size>RESULT_CACHE_LIMIT){
    const oldest=resultCache.keys().next().value;
    resultCache.delete(oldest);
  }
}

function ensureWorker(){
  if(workerState==='unavailable')return null;
  if(worker)return worker;
  try{
    worker=new Worker(new URL('./gnn-placement-worker.js',import.meta.url),{type:'classic'});
    workerState='loading';
    worker.onmessage=event=>{
      const msg=event.data||{};
      if(msg.type==='ready'){workerState='ready';lastModelPath=msg.modelPath||null;return;}
      if(msg.type==='unavailable'){workerState='unavailable';for(const p of pending.values()){clearTimeout(p.timer);p.resolve(null);}pending.clear();return;}
      if(msg.type==='ranked'||msg.type==='error'){
        const p=pending.get(msg.id);if(!p)return;pending.delete(msg.id);clearTimeout(p.timer);
        if(msg.type==='error')p.resolve(null);else p.resolve(msg.result||null);
      }
    };
    worker.onerror=()=>{workerState='unavailable';for(const p of pending.values()){clearTimeout(p.timer);p.resolve(null);}pending.clear();};
    worker.postMessage({type:'init'});
  }catch(_){workerState='unavailable';worker=null;}
  return worker;
}

export function spatialRankerStatus(){
  return {
    state:workerState,
    modelPath:lastModelPath,
    cacheSize:resultCache.size,
    inFlight:inFlightByPayload.size,
    cacheHits,
    inFlightHits,
    rankRequests
  };
}

export async function rankSpatialSolutions(caseObj,effective,solved,{timeoutMs=2500}={}){
  const candidates=solved?.rankingCandidates||[];
  if(candidates.filter(c=>c?.hardValid).length<2)return null;
  const w=ensureWorker();if(!w)return null;
  const payload=buildSpatialRankPayload(caseObj,effective,solved);
  if(!payload.candidate_mask.some(Boolean))return null;

  const cacheKey=payloadCacheKey(payload);
  const cached=getCachedResult(cacheKey);
  if(cached!==undefined){cacheHits++;return cached;}
  if(inFlightByPayload.has(cacheKey)){inFlightHits++;return inFlightByPayload.get(cacheKey);}

  rankRequests++;
  const id=++requestId;
  const promise=new Promise(resolve=>{
    const finish=result=>{
      inFlightByPayload.delete(cacheKey);
      if(result)cacheResult(cacheKey,result);
      resolve(result||null);
    };
    const timer=setTimeout(()=>{pending.delete(id);finish(null);},timeoutMs);
    pending.set(id,{resolve:finish,timer,cacheKey});
    w.postMessage({type:'rank',id,payload});
  });
  inFlightByPayload.set(cacheKey,promise);
  return promise;
}
